export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-bold-e103d2d0ea59ae821bd4526bf3b89b76.ttf";